import { SET_GENERAL_SEARCH_VALUE, SERVER_GET_SEARCH_RESULTS } from 'constants/ActionTypes';

export const setGeneralSearchValue = payload => {
	return { type: SET_GENERAL_SEARCH_VALUE, payload };
};

export const getGeneralSearchResults = searchValue => {
	return {
		type: SERVER_GET_SEARCH_RESULTS,
		payload: { searchValue }
	};
};



// WEBPACK FOOTER //
// ./actions/GeneralSearch.js